import { datesForRange } from 'src/utils/rollup';
import { transactionsByCategories } from './utils';
import useBudget from '../budget';

/**
 * Calculates and returns a forecast based on provided data and parameters.
 *
 * @param {String} period - The period for which the forecast is to be made (e.g., 'monthly', 'yearly').
 * @param {Object} dateRange - The start and end dates defining the range of the forecast.
 * @param {Object} expensesData - The data related to expenses, including transactions and other relevant details.
 * @param {Array} patches - Modifications or adjustments to be applied to the budget.
 *
 * @return {Object} An object containing various details of the expenses forecast,
 *                  including budgets, data segments, aggregate data, historical series,
 *                  and forecasted series.
 */
export default function PrepareForecast(params) {
  const {
    period,
    dateRange,
    expenseData,
    incomeData,
    patches,
    invertValue,
    fullRange,
    weights,
    options,
  } = params;
  const calcPeriod = 'month'; // all computations will occur with monthly segments

  const { rollup } = incomeData ?? expenseData ?? {};
  const { start, end } = fullRange;

  const segments = datesForRange(period, dateRange?.startDate, dateRange?.endDate, params);
  const txSegments = datesForRange(calcPeriod, start, end, params);
  const txByCategories = transactionsByCategories(rollup, txSegments, invertValue, {
    ...weights,
    ...options,
  });

  // ? set start to the first segment of the full range, and the end to the last segment of the render range
  const calcSegments = datesForRange(calcPeriod, start, dateRange?.endDate, params);
  const budgets = useBudget(txByCategories, calcPeriod, patches, calcSegments);

  return {
    period,
    txByCategories,
    budgets,
    segments,
    calcSegments,
    calcPeriod,
  };
}
